// chakra imports
import {
  Avatar,
  Box,
  Flex,
  Stack,
  Text,
  useColorModeValue,
} from '@chakra-ui/react';
import { useCallback, useEffect, useState } from 'react';
import axios from 'axios';
//   Custom components
import Brand from 'components/sidebar/components/Brand';
import Links from 'components/sidebar/components/Links';
import { useAuth } from 'contexts/AuthContext';
import { getBaseUrl } from 'utils/url';
import authBg from 'assets/img/layout/auth-bg.png';

// FUNCTIONS

const getInitials = (name: string) => {
  return name
    .split(' ')
    .map((n) => n[0])
    .join('');
};

function SidebarContent(props: {
  routes: RoutesType[];
  hovered?: boolean;
  mini?: boolean;
}) {
  const { routes, mini, hovered } = props;
  const { user, token } = useAuth() || {};
  const textColor = useColorModeValue('navy.700', 'white');
  const [companyData, setCompanyData] = useState<{
    companyName?: string;
  }>({});

  const fetchCompanyOverview = useCallback(async () => {
    if (!token) return;

    try {
      const response = await axios.get(
        `${getBaseUrl()}/api/accounts/company-overview`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            'Content-Type': 'application/json',
          },
        },
      );
      setCompanyData(response.data);
    } catch (err) {
      // Silently fail - company data is optional
      console.log('Could not fetch company overview:', err);
    }
  }, [token]);

  useEffect(() => {
    fetchCompanyOverview();
  }, [fetchCompanyOverview]);

  // SIDEBAR
  return (
    <Flex
      direction="column"
      height="100%"
      pt="25px"
      borderRadius="30px"
      width="100%"
    >
      <Brand />
      <Stack direction="column" mb="auto" mt="8px">
        <Box
          ps="0px"
          pe="0px"
          ms={mini && hovered === false ? '-16px' : 'unset'}
        >
          <Links mini={mini} hovered={hovered} routes={routes} />
        </Box>
      </Stack>

      <Flex mt="75px" mb="36px" ml="16px" alignItems="center">
        <Avatar
          h="48px"
          w="48px"
          color="black"
          name={getInitials(user?.displayName || '')}
          bgImage={authBg}
          bgSize="90px"
          bgPosition="center"
          me={
            mini === false
              ? '20px'
              : mini === true && hovered === true
              ? '20px'
              : '0px'
          }
        />
        <Box
          display={
            mini === false
              ? 'block'
              : mini === true && hovered === true
              ? 'block'
              : 'none'
          }
        >
          {companyData.companyName && (
            <Text color={textColor} fontSize="md" fontWeight="700" mb="2px">
              {companyData.companyName}
            </Text>
          )}
          <Text color={textColor} fontSize="sm" fontWeight="500">
            {user && user.displayName}
          </Text>
        </Box>
      </Flex>
    </Flex>
  );
}

export default SidebarContent;
